import React, { useState, lazy, Suspense } from 'react';
import { useI18n } from 'hooks/use_i18n';
import '@deecide/redux-json-form/lib/styles/redux-json-form.scss';
import './json_form.scss';
import withJsonFormHelpers from 'components/ui/with_json_form_helpers';
import { getFormLabels, getFormOptions } from 'components/ui/json_form_constants';
import { useJsonFormEditor } from 'components/ui/json_form_editor';
import { useGenie } from 'components/request/genie/provider';
import Loader from 'components/ui/loader';

const JsonFormLazy = lazy(() => import('@deecide/redux-json-form').then((module) => ({ default: module.JsonForm })));

const JsonForm = (props) => {
  const { onSubmit, form, translations, schema, initialValues, disabled, onSubmitSuccess, onSubmitFail, locale, submitValidations, ...rest } = props;
  const { getCurrentLocale, t } = useI18n();
  const { editor, onSetToSchema, onEdit } = useJsonFormEditor();
  const [revalidate, incrementRevalidate] = useState(0);
  const currentLocale = getCurrentLocale();
  const localeForForm = locale || currentLocale;
  const _t = (path, params = {}) => t(path, { locale: localeForForm, ...params });
  const { displayWordInOCR } = useGenie();

  const onAiIconClick = (clickedWord) => {
    displayWordInOCR(clickedWord);
  };

  window['getFormData'] = () => {
    return {
      translations,
      initialValues,
      storeContext: rest.storeContext,
    };
  };
  const formLabels = getFormLabels(_t);
  return (
    <div className="json-form-wrapper">
      <div className="json-form">
        <Suspense fallback={<Loader />}>
          <JsonFormLazy
            locale={localeForForm}
            onSubmit={onSubmit}
            form={form}
            translations={translations}
            schema={schema}
            initialValues={initialValues}
            disabled={disabled}
            submitValidations={submitValidations}
            onSubmitSuccess={onSubmitSuccess}
            onSubmitFail={onSubmitFail}
            enableReinitialize={false}
            formLabels={formLabels}
            options={getFormOptions(t, currentLocale, rest.storeContext?.id)}
            editor={editor}
            onSetToSchema={onSetToSchema}
            onEdit={onEdit}
            showFormErrors={false}
            onAiIconClick={onAiIconClick}
            previewAI
            shouldError={({ nextProps: { revalidateCount, hasError } }) => {
              if (hasError === true) {
                return true;
              }
              if (revalidateCount > revalidate) {
                incrementRevalidate(revalidateCount);
                return true;
              }

              return false;
            }}
            {...rest}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default withJsonFormHelpers(JsonForm);
